import { Component, EventEmitter, Inject, Input, LOCALE_ID, OnDestroy, OnInit, Output } from '@angular/core';
import { switchMap, takeWhile, tap, takeUntil } from 'rxjs/operators';
import { LoginFacade } from '@ridango/components';
import { BaseComponent, OidcAuthService } from '@ridango/core';
import Env from '@ridango/core/env';
@Component({
    selector: 'rwidget-login-form',
    templateUrl: './login-form.component.html',
    styleUrls: ['./login-form.component.scss']
})
export class LoginFormComponent extends BaseComponent implements OnInit, OnDestroy {
    selectedLoginMethod = 'selectedLoginEmail';
    verificationCode?: string;

    @Input() showRequiredText = false;
    @Input() strongAuthOptionsEnabled = false;
    @Input() captchaToggleAllowed = false;
    @Output() onLogin = new EventEmitter<any>();
    @Output() onForgot = new EventEmitter<any>();
    @Output() onLoginIdCard = new EventEmitter<any>();
    @Output() onLoginMobileId = new EventEmitter<any>();
    @Output() onLoginSmartId = new EventEmitter<any>();

    constructor(
        @Inject(LOCALE_ID) public locale: string,
        @Inject('ENV') public env: Env,
        private readonly loginFacade: LoginFacade,
        private readonly oidcAuthService: OidcAuthService
    ) {
        super();
    }

    ngOnInit(): void {
        this.loginFacade.isAuthenticated$
            .pipe(
                takeWhile((authenticated) => !authenticated),
                switchMap(() => this.loginFacade.verificationCode$),
                takeUntil(this.componentDestroyed$)
            )
            .subscribe((code) => {
                this.verificationCode = code;
            });

        this.loginFacade.error$
            .pipe(
                tap((error) => {
                    if (error) {
                        this.resetVerificationCode();
                    }
                }),
                takeUntil(this.componentDestroyed$)
            )
            .subscribe();
    }

    get showVerificationCode() {
        return !!this.verificationCode;
    }

    loginEmail(event: any): void {
        this.onLogin.emit(event);
    }

    loginMobileId(event: any): void {
        this.onLoginMobileId.emit(event);
    }

    loginSmartId(event: any): void {
        this.onLoginSmartId.emit(event);
    }

    loginIdCard() {
        this.onLoginIdCard.emit();
        this.setSelectedLoginMethod('selectedLoginIdCard');
    }

    setSelectedLoginMethod(value: string): void {
        this.selectedLoginMethod = value;
    }

    forgot(): void {
        this.onForgot.emit();
    }

    onFrejaAuthenticationClick(): void {
        const authenticationLanguage = this.locale?.split('-')[0] ?? 'en';
        this.oidcAuthService.start('freja', authenticationLanguage).subscribe({
            next: (oidcAuthStartResponse) => {
                window.location.href = oidcAuthStartResponse.redirectUrl;
            },
            error: (startError) => {
                console.error('Freja LoginForm authentication start request failed', startError);
            }
        });
    }

    cancelChallengePolling(): void {
        this.resetVerificationCode();
        this.loginFacade.cancelChallengePolling();
    }

    resetVerificationCode(): void {
        this.verificationCode = undefined;
    }

    showSelectedLoginMethodForm(method): boolean {
        return this.selectedLoginMethod === method && !this.showVerificationCode;
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }
}
